import axios from "@/libs/api.request";
// 获取列表
export const getBranchShipments = data => {
  return axios.request({
    url: "/finance/branch/overseas/outbound",
    method: "post",
    data
  });
};

export const postRecalculate = data => {
  return axios.request({
    url: "/finance/branch/overseas/outbound/recalculate",
    method: "post",
    data
  });
};

export const createBill = data => {
  return axios.request({
    url: "/finance/branch/overseas/outbound/createBill",
    method: "post",
    data
  });
};

export const cancelHang = data => {
  return axios.request({
    url: "/finance/branch/overseas/outbound/cancelAbnormal",
    method: "post",
    data
  });
};
